import { useState } from 'react';
import translations from 'constants/top';
import lang from 'constants/lang';
import classnames from 'classnames';
import styles from './Header.module.scss';

function MenuItem({ onClick, children }) {
  return (
    <div className={ classnames(styles.menuItem, !onClick && styles.disabled) } onClick={ onClick }>
      <span className={ styles.label }>{ children }</span>
      <img src={ `${process.env.PUBLIC_URL}/images/plus.svg` } alt="" />
    </div>
  );
}

function Header({ page, setPage }) {
  const [showMenu, setShowMenu] = useState(false);

  const onSwitchENHandler = (e) => {
    e.preventDefault();
    if (window.pymChild) {
      window.pymChild.navigateParentTo('https://hypebeast.com/2022/8/metaparade');
    } else {
      window.location.href = '../en/';
    }
  };
  const onSwitchZHHandler = (e) => {
    e.preventDefault();
    if (window.pymChild) {
      window.pymChild.navigateParentTo('https://hypebeast.com/zh/2022/8/metaparade');
    } else {
      window.location.href = '../zh/';
    }
  };
  const onSwitchCNHandler = (e) => {
    e.preventDefault();
    if (window.pymChild) {
      window.pymChild.navigateParentTo('https://hypebeast.cn/2022/8/metaparade');
    } else {
      window.location.href = '../cn/';
    }
  };

  return (
    <nav className={ styles.nav }>
      <div className={ styles.container }>
        <div className={ styles.hypebeast } onClick={ () => setPage('/') }>
          <img src={ `${process.env.PUBLIC_URL}/images/hypebeast.svg` } alt="HYPEBEAST" />
        </div>
        <div className={ styles.plus }>
          <img src={ `${process.env.PUBLIC_URL}/images/plus.svg` } alt="" />
        </div>
        <div className={ styles.hkstp } onClick={ () => setPage('/') }>
          <img src={ `${process.env.PUBLIC_URL}/images/hkstp.svg` } alt="HKSTP" />
        </div>
        <div className={ styles.slogan } onClick={ () => setPage('/') }>
          SUCCESS<br />
          BEYOND BORDERS
        </div>
        <div className={ styles.lang }>
          <a href="https://hypebeast.com/2022/8/metaparade" className={ classnames(lang === 'en' && styles.active) } onClick={ onSwitchENHandler }>EN</a>&nbsp;|&nbsp;
          <a href="https://hypebeast.com/zh/2022/8/metaparade" className={ classnames(lang === 'tc' && styles.active) } onClick={ onSwitchZHHandler }>ZH</a>&nbsp;|&nbsp;
          <a href="https://hypebeast.cn/2022/8/metaparade" className={ classnames(lang === 'sc' && styles.active) } onClick={ onSwitchCNHandler }>CN</a>
        </div>
      </div>

      <div className={ classnames(styles.menu, styles[lang], page !== '/' && styles.menuArtwork, page === '/artwork/argallery' && styles.menuARGallery, showMenu && styles.pointerEventsAll) } onMouseLeave={ () => { setShowMenu(false); } }>
        <div className={ styles.menuWrapper }>
          <div className={ styles.menuButtonMobile } onClick={ () => { setShowMenu(!showMenu); } }>
            <img src={ `${process.env.PUBLIC_URL}/images/hamburger.png` } alt="Menu" />
          </div>
          <div className={ classnames(styles.menuItems, showMenu && styles.visible) }>
            <MenuItem onClick={ () => { setPage('/artwork/innovationpin'); setShowMenu(false); } }>INNOVATION PIN</MenuItem>
            <MenuItem onClick={ () => { setPage('/artwork/ericbot404'); setShowMenu(false); } }>ERICBOT404</MenuItem>
            <MenuItem onClick={ () => { setPage('/artwork/franknitty'); setShowMenu(false); } }>FRANK NITTY</MenuItem>
            <MenuItem onClick={ () => { setPage('/artwork/keithlam'); setShowMenu(false); } }>KEITH LAM &amp; DIMENSION PLUS</MenuItem>
            <MenuItem onClick={ () => { setPage('/artwork/stephlau'); setShowMenu(false); } }>STEPH SHUE YAN LAU</MenuItem>
            <MenuItem onClick={ () => { setPage('/artwork/yarliallison'); setShowMenu(false); } }>YARLI ALLISON</MenuItem>
            <MenuItem onClick={ () => { setPage('/artwork/interview'); setShowMenu(false); } }>BEHIND THE SCENES</MenuItem>
            {/* <MenuItem onClick={ () => { setPage('/artwork/argallery'); setShowMenu(false); } }>META-PARADE <img src={ `${process.env.PUBLIC_URL}/images/ar.svg` } className={ styles.ar } alt="AR" /> { translations.gallery }</MenuItem> */}
          </div>
          <div className={ classnames(styles.menuButton, styles.visible, page !== '/' && styles.menuButtonIcon) } onMouseEnter={ () => { setShowMenu(true); } }>
            {
              page === '/' ? (
                translations.menuButton
              ) : (
                <div className={ styles.metaParade }>
                  <img src={ `${process.env.PUBLIC_URL}/images/meta-parade-white.svg` } alt="META-PARADE" />
                </div>
              )
            }
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Header;